import { useSelector } from 'react-redux'
import styles from '../SuperAdminDashboard.module.scss'

export function AdminWeddingStatsCard() {
	const weddingStats = useSelector((s) => s.admin.weddingStats)
	const weddingStatsLoading = useSelector((s) => s.admin.weddingStatsLoading)
	const weddingStatsError = useSelector((s) => s.admin.weddingStatsError)

	const currentYear = new Date().getFullYear()

	const formatWeddingCount = (field) => {
		if (weddingStatsLoading && weddingStats == null) return '—'
		if (weddingStatsError && weddingStats == null) return '—'
		return String(weddingStats?.[field] ?? 0)
	}

	return (
		<div className={styles.statCard}>
			<h2 className={styles.statCardTitle}>Weddings</h2>
			<div className={styles.statRow}>
				<p className={styles.statLabel}>
					Total weddings created in the system
				</p>
				<p className={styles.statValue}>{formatWeddingCount('total')}</p>
			</div>
			<div className={styles.statRow}>
				<p className={styles.statLabel}>Total future weddings planned</p>
				<p className={styles.statValue}>
					{formatWeddingCount('futurePlanned')}
				</p>
			</div>
			<div className={styles.statRow}>
				<p className={styles.statLabel}>
					Future weddings for {currentYear}
				</p>
				<p className={styles.statValue}>
					{formatWeddingCount('futureThisYear')}
				</p>
			</div>
			{weddingStatsError ? (
				<p className={styles.statsErrorInline}>{weddingStatsError}</p>
			) : null}
		</div>
	)
}
